import defaultTheme from './theme'
import createTextStyles from './createTextStyles';
const deepmerge = require('deepmerge')

/**
 * Adds size aliases to an array of keys.
 *
 * @param arr
 */
const addSizeAliases = (arr: string[]) => {
    arr.forEach((val, key) => {
        arr[['sm', 'md', 'lg', 'xl'][key]] = val
    })

    return arr
}

export default (theme = {}, customBreakpoints = null) => {
    const mergedTheme = deepmerge(defaultTheme, theme)

    return {
        ...mergedTheme,
        contrastRatio: mergedTheme.contrastRatio || 2.6,
        breakpoints: addSizeAliases(customBreakpoints || mergedTheme.breakpoints),
        mediaQueries: addSizeAliases(mergedTheme.mediaQueries),
        textStyles: createTextStyles(mergedTheme)
    }
}
